<!-- Pagination.vue -->
<template>
  <div class="pdf-pagination">
    <button
      v-for="page in totalPages"
      :key="page"
      @click="selectPage(page)"
      :class="{ active: page === currentPage }"
    >
      {{ page }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PdfPagination',
  props: {
    totalPages: Number,
    currentPage: Number,
  },
  methods: {
    selectPage(page) {
      this.$emit('page-selected', page);
    },
  },
};
</script>

<style scoped>
.pdf-pagination {
  margin-top: 20px; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf-pagination button {
  margin: 0 5px;
  padding: 8px 16px;
  background-color: #8C6DFF; 
  color: #fff; 
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.pdf-pagination button:hover {
  background-color: #4d3f7e; 
}

.pdf-pagination button.active {
  background-color: #4d3f7e; 
}
</style>
